import { render } from "./dialogflow.vue?vue&type=template&id=3c832dcb"
import script from "./dialogflow.vue?vue&type=script&lang=js"
export * from "./dialogflow.vue?vue&type=script&lang=js"

import "./dialogflow.vue?vue&type=style&index=0&id=3c832dcb&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__